import { useContext } from "react";
import { CommonContext } from "../context/CommonContext";

const UseCommon = () => {
  return useContext(CommonContext);
};

export default UseCommon;
